import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from '../../../common/propTypes';
import { TextField } from '@material-ui/core';
import usePrevious from '../../../common/hooks/usePrevious';
import LoadingComponent from '../../../common/LoadingComponent';

function AddNotification({ onSave, onCancel, loading }) {
    const [headline, setHeadline] = useState('');
    const [body, setBody] = useState('');

    const prevLoading = usePrevious(loading);

    useEffect(() => {
        if (prevLoading && !loading) {
            onCancel();
        }
    }, [loading]);

    const disable =
        !headline.length ||
        !body.length ||
        headline.length > 48 ||
        body.length > 200;
    return (
        <div className="add-notification">
            <label className="label-text">Headline</label>
            <TextField
                disabled={false}
                value={headline}
                type={'text'}
                placeholder={'Enter headline here (48 characters limit)'}
                onChange={(event) => setHeadline(event.target.value)}
            />
            <label className="label-text">Body</label>
            <TextField
                disabled={false}
                value={body}
                type={'text'}
                placeholder={'Enter bodytext here... (200 characters limit)'}
                multiline
                onChange={(event) => setBody(event.target.value)}
                className="aaa"
            />

            <button
                disabled={disable}
                className="sendBtn"
                onClick={() => onSave({ headline, body })}
            >
                {loading ? <LoadingComponent isLoading={loading} /> : 'Send'}
            </button>
            <button className="cancel" onClick={() => onCancel()}>
                Cancel
            </button>
        </div>
    );
}

AddNotification.propTypes = {
    onSave: PropTypes.func,
    onCancel: PropTypes.func,
    loading: PropTypes.bool,
};

AddNotification.defaultProps = {
    onSave: noop,
    onCancel: noop,
    loading: false,
};

export default AddNotification;
